app = angular.module("seismology")

app.controller "PersonalCtrl", ($scope, $state) ->
  $scope.selectedNavItem = $state.current.name.split('.').reverse()[0]
  console.log $scope.selectedNavItem
  $scope.switchNavItem = (name) ->
    $state.go("dashboard.personal.#{name}")

app.controller "FavListCtrl", ($scope, $window, $location, UserFavs, Books) ->
  $scope.favs = UserFavs.getList()
  $scope.Books = Books
  $scope.moment = $window.moment
  $scope.currentPath = $location.path()    

app.controller "PersonalHistoryCtrl", ($scope, $window, $location, CurrentUser, Timeline, Books) ->
  uid = CurrentUser.get().$id
  $scope.timeline = Timeline.getListByUid(uid, 100)
  console.log $scope.timeline
  $scope.Books = Books
  $scope.moment = $window.moment
  $scope.currentPath = $location.path() 
  
  



// WEBPACK FOOTER //
// ./app/controllers/personal_controllers.coffee